import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";
import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";

import { LargeText, SmallTitle, MediumTitle } from "../../ui-components/texts";

import { useTranslate } from "../../contexts/translate";

// images
import imageCover from "../../media/images/portfolio-images/taormina/image-cover.png";
import { ImageLeftWithText } from "./components-content";

import {
	Column,
	Container,
	ContainerBlock,
} from "../../ui-components/columns/components";
import { TitleWithScrollXImagesSection } from "./components-design";



import { FullWidthVideo } from "../../ui-components/videos";

const Taormina = ({
	setNextPageHref = () => {},
	setNextPageName = () => {},
}) => {
	useEffect(() => {
		setNextPageHref("/projects/topbuildinggroup");
		setNextPageName("Top Building Group");
		document.title =
			"Taormina Caffè - Cutting Edge Digital Creative Studio";
	}, []);

	const { translations } = useTranslate();
	const peoples = [
		{
			fullname: "Andrea Anfuso",
			image: require("../../media/team-images/Andrea Anfuso.jpg").default,
			role: translations === null ? "" : translations.about.peoples[0].role,
			description:
				translations === null ? "" : translations.about.peoples[0].description,
		},
		{
			fullname: "Giuseppe Bussolari",
			image: require("../../media/team-images/Giuseppe Bussolari.jpg").default,
			role: translations === null ? "" : translations.about.peoples[8].role,
			description:
				translations === null ? "" : translations.about.peoples[8].description,
		},
		{
			fullname: "Luca Colombo",
			image: require("../../media/team-images/no-image.png").default,
			role: translations === null ? "" : translations.about.peoples[19].role,
			description:
				translations === null ? "" : translations.about.peoples[19].description,
		},
		
	];

	return (
		<div className="project-page project-page-cips">
			<CoverPorfolio
				background="#153B59"
				className="theme-dark"
				title="Taormina Caffè"
				white={true}
				text={translations && translations.taormina.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"Taormina Caffè"}
				services={[
					"Brand Strategy",
					"Content Production",
					"Social Media Management",
					"Advertising ",
				]}
				timeframe={"2023"}
				introduction={
					<>
						<LargeText>
							{translations && translations.taormina.descriptions[0]}
						</LargeText>
					</>
				}
			/>

			<TitleWithScrollXImagesSection
				className="theme-dark"
				color={"#3C4043"}
				title={translations && translations.taormina.sections[0].title}
				text={translations && translations.taormina.sections[0].text1}
				items={[
					{
						src: require("../../media/images/portfolio-images/taormina/gallery/1.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/taormina/gallery/2.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/taormina/gallery/3.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/taormina/gallery/4.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/taormina/gallery/5.png")
							.default,
					}
				]}
			/>
<section className="theme-light" style={{ background: "#fff" }}>
				<Container>
					<div className="wrapper fluid pt-5 pb-0">
						<Column>
							<MediumTitle>
								{translations && translations.taormina.sections[1].title}
							</MediumTitle>
							<LargeText>
								{translations && translations.taormina.sections[1].text}
							</LargeText>
							
						</Column>
					</div>
				</Container>

				
			</section>


			<ImageLeftWithText
				className="theme-light"
				color="#fff"
				//title={translations && translations.ohoskin.sections[0].title}
				texts={[translations && translations.taormina.sections[2].title, translations && translations.taormina.sections[2].text]}
				image={
					require("../../media/images/portfolio-images/taormina/image-sx.png")
						.default
				}
			/>
			<TitleWithScrollXImagesSection
			   white={false}
				color={"#f5d99a"}
				className="theme-light"
				title={translations && translations.taormina.sections[3].title}
				text={translations && translations.taormina.sections[3].text}
				
			/>

			<PeopleOfMasamune peoples={peoples} />
					<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Taormina.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Taormina;
